"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-12-20 11:01:16
 * @LastEditTime: 2021-12-20 13:51:57
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\render\SanKey.ts
 */
exports.default = {
    draggable: false,
    nodeAlign: "left",
    top: 10,
    bottom: 10,
    left: 30,
    right: 0,
    nodeWidth: 5,
    nodeGap: 12,
    label: {
        position: "left",
        backgroundColor: "transparent"
    },
    lineStyle: {
        color: "source",
        curveness: 0.15
    }
};
//# sourceMappingURL=SanKey.js.map